export default class CancelCurrentAgent {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.currentAgent.clearErrors();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/current_agent/cancel_current_agent.js